module.exports = __webpack_public_path__ + "img/zyjy_04.4c178357.png";